<template>
  <Editor
    ref="formEditor"
    class="tag-editor"
    :loading.sync="loading"
    :titleI18nKey="`admin.crm.title.tag.${isEditMode ? 'editTask' : 'addTask'}`"
    :model="task"
    :formLines="formLines"
    @cancel="handleCancel"
    @save="handleSave"
  >
    <template #tags="{ lineName }">
      <el-select
        v-model="task[lineName]"
        clearable
        multiple
        :placeholder="$t('admin.crm.placeholder.tag.tagList')"
      >
        <el-option
          v-for="item in totalActiveTags"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </template>
  </Editor>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import Editor from '../editor.vue'

export default {
  components: {
    Editor
  },
  data () {
    return {
      loading: false,
      task: {
        tags: []
      },
      totalActiveTags: []
    }
  },
  computed: {
    isEditMode () {
      return this.$route.meta.isEditMode
    },
    formLines () {
      const lines = {
        name: {
          labelI18nKey: 'admin.crm.label.tag.taskName',
          placeholderI18nKey: 'admin.crm.placeholder.tag.taskName',
          rules: [
            { required: true, message: this.$t('admin.crm.message.tag.taskName'), trigger: 'change' },
            { validator: this.validatorTagName, trigger: 'change' }
          ]
        },
        tags: {
          labelI18nKey: 'admin.crm.label.tag.tagList',
          rules: [{ required: true, message: this.$t('admin.crm.message.tag.tagList'), trigger: 'change' }]
        }
      }
      return lines
    },
    form () {
      return this.$refs.formEditor.form
    }
  },
  created () {
    this.loading = true
    const promiseList = [this.getActiveTags()]
    if (this.isEditMode) {
      promiseList.push(this.getTask())
    }
    Promise.all(promiseList).finally(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions('crm', ['getTagTaskById', 'createTagTask', 'updateTagTask', 'searchTag']),
    async getTask () {
      const taskId = this.$route.params.taskId
      const resp = await this.getTagTaskById(taskId)
      if (resp) {
        const tags = []
        _.forEach(resp.tag_list, item => { tags.push(_.toInteger(item.id)) })
        this.task = {
          id: resp.id,
          name: resp.name,
          tags: tags
        }
      }
    },
    async getActiveTags () {
      const params = {
        is_company_tag: 1,
        tag_category: 'smart'
      }
      const resp = await this.searchTag(params)
      if (resp) {
        this.totalActiveTags = resp
      }
    },
    validatorTagName (rule, value, callback) {
      if (typeof value === 'string' && !value.trim()) {
        callback(this.$t('admin.crm.message.tag.taskName'))
      }
      callback()
    },
    handleCancel () {
      this.$router.go(-1)
    },
    async handleSave (closeLoading) {
      const taskParams = {
        name: this.task.name,
        tags: this.task.tags
      }
      let saveFunction = null
      if (this.isEditMode) {
        taskParams.id = this.task.id
        saveFunction = this.updateTagTask
      } else {
        saveFunction = this.createTagTask
      }
      const resp = await saveFunction(taskParams)
      if (resp) {
        closeLoading()
        this.$router.push({ name: 'tagTaskList' })
      } else {
        this.$message.error(this.$t('admin.crm.message.tag.requestError'))
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
</style>
